import { ButtonClean, useModalContext } from '@fourthwall/components';
import { TransactionSummaryModal } from '@modules/Dashboard/pages/Settings/pages/Billing/pages/Transactions/components/TransactionSummaryModal/TransactionSummaryModal';
import { routing } from '@utils/routing';
import { reverse } from 'named-urls';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
export const TransactionIdLink = ({ transaction }) => {
    const location = useLocation();
    const getDonationPath = (donationId) => {
        return reverse(routing.contributions.orders.donations.donation.self, { donationId });
    };
    const getOrderPath = (orderId) => {
        return reverse(routing.contributions.orders.order.self, { orderId });
    };
    const pathNames = useMemo(() => {
        return {
            DONATION: (donationId) => {
                return donationId && getDonationPath(donationId);
            },
            DONATION_CANCEL: (donationId) => {
                return donationId && getDonationPath(donationId);
            },
            ORDER: (orderId) => {
                return orderId && getOrderPath(orderId);
            },
            ORDER_REFUND: (orderId) => {
                return orderId && getOrderPath(orderId);
            },
            ORDER_CANCEL: (orderId) => {
                return orderId && getOrderPath(orderId);
            },
            ORDER_PARTIAL_CANCEL: (orderId) => {
                return orderId && getOrderPath(orderId);
            },
            INVENTORY_SHIPMENT: (shippingId) => {
                return (shippingId && reverse(routing.settings.shipping.inventoryShipments.self, { shippingId }));
            },
            INVENTORY_STORAGE: (snapshotId) => {
                return snapshotId && reverse(routing.settings.shipping.inventoryStocks.self, { snapshotId });
            },
        };
    }, []);
    const getFromState = (location) => {
        return { from: { label: 'Earnings history', location } };
    };
    const getPathname = ({ type, originalId }) => {
        const pathName = pathNames[type];
        return pathName && pathName(originalId);
    };
    const getButtonProps = (transaction, location) => {
        const { open, close } = useModalContext();
        const pathname = getPathname(transaction);
        if (pathname) {
            return { to: { pathname, state: getFromState(location) } };
        }
        return { onClick: () => open(TransactionSummaryModal, { transaction, onClose: close }) };
    };
    return React.createElement(ButtonClean, { label: `#${transaction.id}`, ...getButtonProps(transaction, location) });
};
